<template>
  <div>
    <b-row>
      <b-col md="4">
        <!-- ignored: the filter does not join the parameter form that is saved. -->
        <FormulateInput
          id="rate-history-type"
          v-model="filters.type"
          type="vue-select"
          ignored
          :label="$t('Tributo')"
          :placeholder="$t('Todos')"
          :options="typeOptions"
        />
      </b-col>
      <b-col md="4">
        <FormulateInput
          id="rate-history-period"
          v-model="filters.period"
          type="date-range-picker"
          ignored
          :time-picker="false"
          :label="$t('Vigência')"
        />
      </b-col>
    </b-row>
    <b-table
      :items="items"
      :fields="fields"
      :busy="fetching"
      small
      class="bordered table-no-minheight"
      show-empty
      :empty-text="$t('Nenhuma vigência cadastrada.')"
      responsive
      striped
      :tbody-tr-class="rowClass"
    >
      <template #cell(status)="{ item }">
        <b-badge :variant="statusVariant[item.status]">
          {{ statusLabel[item.status] }}
        </b-badge>
      </template>
    </b-table>
    <small class="text-muted">
      {{ $t('Somente consulta. Alíquotas de referência por vigência.') }}
    </small>
  </div>
</template>

<script>
import moment from 'moment'
import { BTable, BBadge, BRow, BCol } from 'bootstrap-vue'
import { alerts } from '@/mixins'

export default {
  name: 'FiscalTaxParameterRateHistory',
  components: { BTable, BBadge, BRow, BCol },
  mixins: [alerts],

  data() {
    return {
      fetching: false,
      items: [],
      filters: this.getDefaultFilters(),
    }
  },

  computed: {
    typeLabel() {
      return {
        Cbs: this.$t('CBS'),
        IbsState: this.$t('IBS UF'),
        IbsMunicipal: this.$t('IBS Municipal'),
      }
    },
    statusLabel() {
      return {
        Previous: this.$t('Anterior'),
        Current: this.$t('Vigente'),
        Next: this.$t('Próxima'),
        Future: this.$t('Futura'),
      }
    },
    statusVariant() {
      return {
        Previous: 'secondary',
        Current: 'success',
        Next: 'info',
        Future: 'primary',
      }
    },
    typeOptions() {
      return Object.entries(this.typeLabel).map(([value, label]) => ({ value, label }))
    },
    fields() {
      return [
        {
          label: this.$t('Tributo'),
          key: 'type',
          formatter: value => this.typeLabel[value] ?? value,
        },
        {
          label: this.$t('Alíquota'),
          key: 'ratePercent',
          class: 'text-center',
          formatter: value => this.$options.filters.percentage(value, 4),
        },
        {
          label: this.$t('Início'),
          key: 'dateStart',
          class: 'text-center',
          formatter: value => this.$options.filters.date(value),
        },
        {
          label: this.$t('Fim'),
          key: 'dateEnd',
          class: 'text-center',
          formatter: value => (value ? this.$options.filters.date(value) : '-'),
        },
        {
          label: this.$t('Situação'),
          key: 'status',
          class: 'text-center',
        },
        {
          label: this.$t('Última atualização'),
          key: 'updatedDate',
          class: 'text-center',
          formatter: value => (value ? this.$options.filters.datetime(value) : '-'),
        },
      ]
    },
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.getData()
      },
    },
  },

  mounted() {
    this.getData()
  },

  methods: {
    async getData() {
      const { type, period } = this.filters
      // Send only the day, to not shift the date with the time zone.
      const toDay = date => (date ? moment(date).format('YYYY-MM-DD') : undefined)
      try {
        this.fetching = true
        const { data } = await this.$http.get('/api/tax/tax-reform/rates/history', {
          params: {
            type: type || undefined,
            periodStart: toDay(period?.startDate),
            periodEnd: toDay(period?.endDate),
          },
        })
        this.items = data ?? []
      } catch (error) {
        this.showGenericError({ error })
      } finally {
        this.fetching = false
      }
    },

    getDefaultFilters() {
      // Default: previous, current and next year.
      return {
        type: null,
        period: {
          startDate: moment().subtract(1, 'year').startOf('year').format(),
          endDate: moment().add(1, 'year').endOf('year').format(),
        },
      }
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return ''
      const variant = this.statusVariant[item.status]
      return variant ? `table-${variant}` : ''
    },
  },
}
</script>
